/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetMehrarbeitsverbuchungForMitarbeiter$Params {

/**
 * ID des Mitarbeiters
 */
  mitarbeiterId: string;

/**
 * Monat für den die Auswertung erstellt werden soll
 */
  monat: string;
}

export function getMehrarbeitsverbuchungForMitarbeiter(http: HttpClient, rootUrl: string, params: GetMehrarbeitsverbuchungForMitarbeiter$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, getMehrarbeitsverbuchungForMitarbeiter.PATH, 'get');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
    rb.path('monat', params.monat, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

getMehrarbeitsverbuchungForMitarbeiter.PATH = '/v1/mitarbeiter/{mitarbeiterId}/mehrarbeitsverbuchung/{monat}';
